// IDs may cross JSON/storage boundaries as strings or numbers. Do not coerce
// missing IDs, booleans, or objects into a matching card ID.
export function sameCardId(left, right) {
  const valid = value => typeof value === 'string' || typeof value === 'number';
  if (!valid(left) || !valid(right)) return false;
  if (typeof left === typeof right) return left === right;
  const numeric = typeof left === 'number' ? left : right;
  const text = typeof left === 'string' ? left : right;
  return text.trim() !== '' && Number.isFinite(numeric) && Number(text) === numeric;
}

// Older API responses use 0/1 in addition to JSON booleans.
export function matchesApiFlag(value, expected) {
  if (value === null || value === undefined) return false;
  if (!['boolean', 'number', 'string'].includes(typeof value)) return false;
  return Number(value) === (expected ? 1 : 0);
}

export function isMissingBillingField(value) {
  return value === '' || value === 0 || value === false || value === null ||
    value === undefined || !['string', 'number'].includes(typeof value);
}
